import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { FormattedMessage, injectIntl } from 'react-intl';

const EmptyCartWarningModal = (props) => {
    const { onClose, messageId, isOpen } = props;
    return (
        <Modal show={isOpen} bsSize="large" aria-labelledby="contained-modal-title-lg" onHide={() => onClose(false)}>
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-lg">
                    <FormattedMessage id="modal-store-title" defaultMessage="Alert" />
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>
                    <FormattedMessage id={messageId} defaultMessage="default" />
                </p>
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={() => onClose(true)}>
                    <FormattedMessage id="modal-store-button-empty" defaultMessage="Empty" />
                </Button>
                <Button onClick={() => onClose(false)}>
                    <FormattedMessage id="modal-store-button-close" defaultMessage="Cancel" />
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default injectIntl(EmptyCartWarningModal);



/** WEBPACK FOOTER **
 ** ./src/components/shared/empty-cart-warning-modal.js
 **/